import { Banner, type BannerProps } from '@/components/Banner'
import { Container, type BackgroundColor, type Space } from '@/components/Container'
import { clearBuilderProps } from '@/core/utils/dom/clearBuilderProps'

interface BannerBlockProps extends BannerProps {
  id?: string
  background: BackgroundColor
  space?: Space
}

const BannerBlock = ({ id, background, space = 'm', ...bannerProps }: BannerBlockProps) => {
  clearBuilderProps(bannerProps)
  return (
    <Container backgroundColor={background} spaceOut={space} spaceIn="m" id={id}>
      <Banner {...bannerProps} />
    </Container>
  )
}

export default BannerBlock
